import {
  DropDownButton,
  type DropDownButtonProps,
} from '@progress/kendo-react-buttons'
import React from 'react'

import {
  getButtonClassName,
  type StyledButtonCommonProps,
} from '~/components/common/StyledButton'

export type StyledDropDownButtonProps = DropDownButtonProps &
  StyledButtonCommonProps & {
    'data-testid'?: string
  }

export const StyledDropDownButton = (props: StyledDropDownButtonProps) => {
  const {
    buttonStyle: _buttonStyle,
    children,
    className: _className,
    'data-testid': dataTestId = 'components-elements-styled-drop-down-button',
    noPadding: _noPadding,
    ...rest
  } = props

  return (
    <DropDownButton
      className={getButtonClassName(props)}
      data-testid={dataTestId}
      {...rest}
    >
      {children}
    </DropDownButton>
  )
}
